import Main from "../../shared/main";

const Keyword = (props) => {
  return (
    <div id="bot-scene-container" className="">
      <div id="bot-scene-content" className="scroll-light">
        <div className="app-v2-header-wrapper has-subtitle has-extra">
          <div className="app-v2-header-left"><span className="app-v2-header-title">Tất cả bài viết</span><span
            className="app-v2-header-subtitle">Phản hồi bình luận tự động cho tất cả bài viết. <a
              href="" target="_blank">Tìm hiểu
              thêm</a></span></div>
          <div className="app-v2-header-extra-wrapper">
            <div className="app-v2-header-extra-item">
              <div className="text-danger"><span>Tạm ngưng</span></div>
            </div>
            <div className="app-v2-header-extra-item">
              <div className="ml8"><button type="button" className="app-switch app-switch-small auto-comment__header-switch"><span
                className="app-switch-inner"></span>
                <div className="app-click-animating-node"></div>
              </button><span className="ml8">Kích hoạt</span></div>
            </div>
            <div className="app-v2-header-extra-item"><button type="button"
              className="app-btn app-btn-primary auto-comment__header-button-save ml12">
              <div className="svg-next-icon ic-save-outline-white">
              </div><span className="ml8">Lưu</span>
            </button></div>
          </div>
        </div>
        <div className="app-v2-layout-content auto-comment">
          <div className="display-flex">
            <div className="auto-comment-keyword">
              <div className="auto-comment-collapse-container">
                <div className="app-collapse app-collapse first">
                  <div className="app-collapse-item app-collapse-item-active">
                    <div className="app-collapse-header" role="button" tabIndex="0" aria-expanded="true">
                      <div className="svg-next-icon app-collapse-arrow ic-file">
                      </div>
                      <div className="auto-comment-collapse-container__title ml8 line-height-20 font-size-18">Nội dung phản hồi
                      </div>
                      <div className="app-collapse-extra">
                        <div className="display-flex align-items-center height100">
                          <div className="svg-next-icon ic-collapse">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="app-collapse-content app-collapse-content-active">
                      <div className="app-collapse-content-box">
                        <div className="auto-comment-response-content line-height-20">
                          <div className="mt20">
                            <div className="auto-comment-collapse-inside mt16">
                              <div className="app-collapse">
                                <div className="app-collapse-item app-collapse-item-active">
                                  <div className="app-collapse-header" role="button" tabIndex="0" aria-expanded="true">
                                    <div
                                      className="auto-comment-collapse-inside__title line-height-20 flex-display-justify-content-center">
                                      <div className="text-font-weight-500"><span>Nhóm từ khóa 1</span></div>
                                    </div>
                                    <div className="app-collapse-extra">
                                      <div className="display-flex align-items-center height100">
                                        <div className="svg-next-icon ic-collapse">
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="app-collapse-content app-collapse-content-active">
                                    <div className="app-collapse-content-box">
                                      <div className="auto-comment-response-content__editor">
                                        <div className="editor-padding text-font-weight-500"><span>Bình luận chứa ít nhất một
                                          trong các từ khoá (tối đa 4 từ)</span>
                                          <div className="input-keyword mt8">
                                            <div className="app-badges app-badges--status-primary-string input-keyword__badges">
                                              <div className="app-badges-body"><span className="text-nowrap content"
                                                title="123">123</span>
                                                <div className="pointer button-delete">
                                                  <div>
                                                    <div className="svg-next-icon next-close">
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div><input className="input-keyword__text text-no-bold" placeholder="" value="" />
                                          </div>
                                          <div className="line-height-20 font-size-12 mt8 text-no-bold"
                                            style={{ color: "rgb(13, 26, 49)" }}><span>Nhấn Enter để thêm từ khóa mới</span>
                                          </div>
                                        </div>
                                        <div className="editor-padding text-font-weight-500 mt16"><span>Phản hồi qua
                                          Messenger</span></div>
                                        <div className="message-flow-editor">
                                          <div className="block-editor-wrapper">
                                            <div className="block-editor col-auto block-editor-auto-comment">
                                              <div className="block-breadcrumb">
                                                <div className="block-breadcrumb-container"><span><a><span className="pointer">Phản
                                                  hồi trong Messenger</span></a></span></div>
                                              </div>
                                              <div className="block-card-list block-card-list-auto-comment">
                                                <nav>
                                                  <div className="card-editor fadeInDown animated">
                                                    <div className="card-item card-item-text">
                                                      <div className="input-text input-text-none-scrollbar text-multi">
                                                        <div data-slate-editor="true" data-key="148" contentEditable="true"
                                                          className="" spellCheck="true" role="textbox" data-gramm="false"
                                                          style={{ outline: "none", whiteSpace: "pre-wrap", overflowWrap: "break-word", WebkitUserModify: "read-write-plaintext-only" }}>
                                                          <div data-key="147" style={{ position: "relative" }}><span
                                                            data-key="146"><span data-offset-key="146-0">Bạn cho shop thêm
                                                              thông tin liên hệ để shop hỗ trợ nhé!</span></span></div>
                                                        </div>
                                                      </div>
                                                      <div className="button-editor"><span
                                                        className="pointer text-ellipsis   add-more text-center">
                                                        <div className="button-editor-wrapper"><span
                                                          className="button-content"><span className="">+ Thêm nút</span></span>
                                                        </div>
                                                      </span></div>
                                                    </div>
                                                    <div className="card-action-container"><a><svg ariaHidden="true"
                                                      focusable="false" dataprefix="fas" dataicon="times"
                                                      className="svg-inline--fa fa-times fa-w-11 card-action mt5" role="img"
                                                      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
                                                      <path fill="currentColor"
                                                        d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
                                                      </path>
                                                    </svg></a></div>
                                                  </div>
                                                </nav>
                                              </div>
                                              <div className="add-card-editor">
                                                <div className="add-card-container p-l20 p-r20">
                                                  <div
                                                    className="add-card-item add-card-item-disabled add-card-item-disabled-click"
                                                    title="">
                                                    <div className="add-card-icon"><svg ariaHidden="true" focusable="false"
                                                      dataprefix="fas" dataicon="align-left"
                                                      className="svg-inline--fa fa-align-left fa-w-14 font-size-23" role="img"
                                                      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                                      <path fill="currentColor"
                                                        d="M288 44v40c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V44c0-8.837 7.163-16 16-16h256c8.837 0 16 7.163 16 16zM0 172v40c0 8.837 7.163 16 16 16h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16zm16 312h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm256-200H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16h256c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16z">
                                                      </path>
                                                    </svg></div>
                                                    <div className="add-card-title text-smaller"><span>+ Văn bản</span></div>
                                                  </div>
                                                  <div
                                                    className="add-card-item add-card-item-disabled add-card-item-disabled-click"
                                                    title="">
                                                    <div className="add-card-icon"><svg ariaHidden="true" focusable="false"
                                                      dataprefix="far" dataicon="image"
                                                      className="svg-inline--fa fa-image fa-w-16 font-size-23" role="img"
                                                      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                      <path fill="currentColor"
                                                        d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z">
                                                      </path>
                                                    </svg></div>
                                                    <div className="add-card-title text-smaller"><span>+ Hình ảnh</span></div>
                                                  </div>
                                                  <div
                                                    className="add-card-item add-card-item-disabled add-card-item-disabled-click"
                                                    title="">
                                                    <div className="add-card-icon"><svg ariaHidden="true" focusable="false"
                                                      dataprefix="far" dataicon="map"
                                                      className="svg-inline--fa fa-map fa-w-18 font-size-23" role="img"
                                                      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                                      <path fill="currentColor"
                                                        d="M560.02 32c-1.96 0-3.98.37-5.96 1.16L384.01 96H384L212 35.28A64.252 64.252 0 0 0 191.76 32c-6.69 0-13.37 1.05-19.81 3.14L20.12 87.95A32.006 32.006 0 0 0 0 117.66v346.32C0 473.17 7.53 480 15.99 480c1.96 0 3.97-.37 5.96-1.16L192 416l172 60.71a63.98 63.98 0 0 0 40.05.15l151.83-52.81A31.996 31.996 0 0 0 576 394.34V48.02c0-9.19-7.53-16.02-15.98-16.02zM224 90.42l128 45.19v285.97l-128-45.19V90.42zM48 418.05V129.07l128-44.53v286.2l-.64.23L48 418.05zm480-35.13l-128 44.53V141.26l.64-.24L528 93.95v288.97z">
                                                      </path>
                                                    </svg></div>
                                                    <div className="add-card-title text-smaller"><span>+ Bộ sưu tập</span></div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="editor-padding">
                                          <div className="">
                                            <div className="auto-comment-switch display-flex"><button type="button"
                                              className="app-switch app-switch-checked app-switch-small"><span
                                                className="app-switch-inner"></span>
                                              <div className="app-click-animating-node"></div>
                                            </button>
                                              <div
                                                className="auto-comment-switch__title ml8 line-height-24 text-font-weight-500">
                                                <span>Phản hồi qua bình luận</span></div>
                                            </div>
                                            <div className="bg-color-white">
                                              <div
                                                className="input-text input-text-none-scrollbar text-multi none-background-color auto-comment-response-content__input mt8">
                                                <div data-slate-editor="true" data-key="140" contentEditable="true" className=""
                                                  spellCheck="true" role="textbox" data-gramm="false"
                                                  style={{ outline: "none", whiteSpace: "pre-wrap", overflowWrap: "break-word", WebkitUserModify: "read-write-plaintext-only" }}>
                                                  <div data-key="139" style={{ position: "relative" }}><span data-key="142"><span
                                                    data-offset-key="142-0"><span
                                                      data-slate-zero-width="true"> </span></span></span><span
                                                        data-slate-void="true"><span style={{ color: "transparent" }}><span
                                                          data-offset-key="141-0"><span
                                                            data-slate-zero-width="true"> </span></span></span><span
                                                              contentEditable="false"><span
                                                                className="input-text-plugins-vars-item pointer" data-type="full_name"
                                                                data-fallback=""><span className="badges badges-primary">Họ và
                                                                  Tên</span></span></span></span><span data-key="138"><span
                                                                    data-offset-key="138-0"> ơi! Shop đã gửi tin cho bạn, bạn kiểm tra
                                                                    tin nhắn nhé</span></span></div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div><button type="button" className="app-btn app-btn-primary w100 mt16 text-font-weight-500">
                              <div className="svg-next-icon ic-plus">
                              </div><span className="mt2 ml8">Thêm nhóm từ khóa</span>
                            </button>
                              <div className="mt16"><span><strong>Lưu ý:</strong> Bạn có thể tạo tối đa 10 nhóm từ khóa.</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="auto-comment-collapse-container auto-comment-vertical-line">
                <div className="app-collapse app-collapse first">
                  <div className="app-collapse-item app-collapse-item-active">
                    <div className="app-collapse-header" role="button" tabIndex="0" aria-expanded="true">
                      <div className="svg-next-icon app-collapse-arrow ic-folder-plus">
                      </div>
                      <div className="auto-comment-collapse-container__title ml8 line-height-20 font-size-18">Điều kiện phản hồi
                      </div>
                      <div className="app-collapse-extra">
                        <div className="display-flex align-items-center height100">
                          <div className="svg-next-icon ic-collapse">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="app-collapse-content app-collapse-content-active">
                      <div className="app-collapse-content-box">
                        <div className="auto-comment-response-condition line-height-20">
                          <div>
                            <div className="text-font-weight-500"><span>Nội dung trong bình luận</span></div>
                            <div className="auto-comment-switch display-flex mt8"><button type="button"
                              className="app-switch app-switch-small"><span className="app-switch-inner"></span>
                              <div className="app-click-animating-node"></div>
                            </button>
                              <div className="auto-comment-switch__title ml8"><span>Có chứa số điện thoại</span></div>
                            </div>
                          </div>
                          <div className="mt20">
                            <div className="text-font-weight-500"><span>Đối tượng khách hàng</span></div>
                            <div className="auto-comment-switch display-flex mt8"><button type="button"
                              className="app-switch app-switch-small"><span className="app-switch-inner"></span>
                              <div className="app-click-animating-node"></div>
                            </button>
                              <div className="auto-comment-switch__title ml8"><span>Chỉ gửi phản hồi cho khách hàng lần đầu
                                tương tác với page</span></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="auto-comment-collapse-container auto-comment-vertical-line">
                <div className="app-collapse app-collapse first">
                  <div className="app-collapse-item app-collapse-item-active">
                    <div className="app-collapse-header" role="button" tabIndex="0" aria-expanded="true">
                      <div className="svg-next-icon app-collapse-arrow ic-adjust">
                      </div>
                      <div className="auto-comment-collapse-container__title ml8 line-height-20 font-size-18">Cấu hình nâng cao
                      </div>
                      <div className="app-collapse-extra">
                        <div className="display-flex align-items-center height100">
                          <div className="svg-next-icon ic-collapse">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="app-collapse-content app-collapse-content-active">
                      <div className="app-collapse-content-box">
                        <div className="auto-comment-advanced-setting">
                          <div className="line-height-20 text-font-weight-500"><span>Thời gian gửi phản hồi</span></div>
                          <div className="mt16 line-height-18">
                            <div className="app-next-input-radio mt12"><label className="app-next-label--switch"
                              for="app-radio-5">Ngay lập tức</label><input className="app-next-radio" type="radio"
                                id="app-radio-5" value="" checked="" /><span className="app-next-radio--styled"></span></div>
                            <div className="app-next-input-radio mt12"><label className="app-next-label--switch"
                              for="app-radio-6">Sau khoảng thời gian tối thiểu</label><input className="app-next-radio"
                                type="radio" id="app-radio-6" value="" /><span className="app-next-radio--styled"></span></div>
                          </div>
                          <div className="mt20">
                            <hr />
                          </div>
                          <div className="mt20">
                            <div className="line-height-20 text-font-weight-500 mb8"><span>Hành động đi kèm khi khách hàng bình
                              luận</span></div>
                            <div className="actions-container"><span
                              className="button-action-container border-bottom2 bold-border-i pointer" id="dont-close-popup">
                              <div className="app-btn app-btn-default btn-add-actions">
                                <div className="svg-next-icon ic-plus">
                                </div><span className="mt2 ml8">Thêm hành động</span>
                              </div>
                            </span></div>
                          </div>
                          <div className="mt20">
                            <div className="line-height-20 text-font-weight-500 mb8"><span>Hành động Opt-in đi kèm khi khách
                              hàng trả lời tin nhắn</span></div>
                            <div className="actions-container"><span
                              className="button-action-container border-bottom2 bold-border-i pointer" id="dont-close-popup">
                              <div className="app-btn app-btn-default btn-add-actions">
                                <div className="svg-next-icon ic-plus">
                                </div><span className="mt2 ml8">Thêm hành động</span>
                              </div>
                            </span></div>
                          </div>
                          <div className="mt20">
                            <div className="app-alert app-alert-warning app-alert-has-icon"><span className="app-alert-icon"><svg
                              className="app-svg-inline-block" width="14px" height="14px" viewBox="0 0 50 47">
                              <path
                                d="M28.5714 38.5078C28.5714 39.01 28.1808 39.4286 27.6786 39.4286H22.3214C21.8192 39.4286 21.4286 39.01 21.4286 38.5078V33.2065C21.4286 32.7042 21.8192 32.2857 22.3214 32.2857H27.6786C28.1808 32.2857 28.5714 32.7042 28.5714 33.2065V38.5078ZM28.5156 28.0725C28.4877 28.4353 28.0692 28.7143 27.567 28.7143H22.4051C21.875 28.7143 21.4565 28.4353 21.4565 28.0725L20.9821 15.3214C20.9821 15.154 21.0658 14.875 21.2612 14.7355C21.4286 14.596 21.6797 14.4286 21.9308 14.4286H28.0692C28.3203 14.4286 28.5714 14.596 28.7388 14.7355C28.9342 14.875 29.0179 15.0982 29.0179 15.2656L28.5156 28.0725ZM28.125 2.01228C27.5112 0.868302 26.3114 0.142854 25 0.142854C23.6886 0.142854 22.4888 0.868302 21.875 2.01228L0.446429 41.298C-0.167411 42.3862 -0.139509 43.7254 0.502232 44.8136C1.14397 45.9018 2.31585 46.5714 3.57143 46.5714H46.4286C47.6842 46.5714 48.856 45.9018 49.4978 44.8136C50.1395 43.7254 50.1674 42.3862 49.5536 41.298L28.125 2.01228Z">
                              </path>
                            </svg></span><span className="app-alert-message"><b>Lưu ý:</b><br />Các hành động liên quan đến
                              kịch bản chăm sóc chỉ được áp dụng đối với khách hàng đã đăng ký theo dõi chatbot hoặc nhắn
                              tin cho trang. <a
                                href=""
                                className="view-instruction" target="_blank">Xem hướng dẫn</a></span><span
                                  className="app-alert-description"></span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="preview-container auto-comment-preview-post auto-comment-preview-post--delay">
              <div className="preview-container__screen">
                <div className="preview-status-bar">
                  <div className="preview-status-bar__time"><span>08:53 CH</span></div>
                  <div className="preview-status-bar__energy">
                    <div className="svg-next-icon ic-phone-status">
                    </div>
                  </div>
                  <div className="preview-status-bar__white-block"></div>
                </div>
                <div className="preview-store-info">
                  <div className="preview-store-info__arrow-image">
                    <div className="svg-next-icon ic_back">
                    </div>
                  </div>
                  <div className="preview-store-info__avatar"><span content="Ngày mới vui vẻ"
                    className="app-avatar app-avatar-circle app-avatar-image"
                    style={{ width: 26, height: 26, lineHeight: 26, background: "rgb(253, 189, 65)" }}><img
                      src="/call/social_avatar_api/profile_avatar/participants/123572544060106/channels/1/pages/123572544060106/?size=70" /></span>
                  </div>
                  <div className="preview-store-info__name text-ellipsis"><span>Ngày mới vui vẻ</span></div>
                </div>
                <div className="preview-container__body">
                  <div className="preview-messages">
                    <div className="row-wrapper">
                      <div className=""><span content="Ngày mới vui vẻ" className="app-avatar app-avatar-circle app-avatar-image"
                        style={{ width: 24, height: 24, lineHeight: 24, background: "rgb(253, 189, 65)" }}><img
                          src="/call/social_avatar_api/profile_avatar/participants/123572544060106/channels/1/pages/123572544060106/?size=70" /></span>
                      </div>
                      <div className="row-wrapper__children">
                        <div className="card-text">
                          <div className="card-text__content"><span>Bạn cho shop thêm thông tin liên hệ để shop hỗ trợ
                            nhé!</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="preview-footer">
                  <div className="preview-footer__menu">
                    <div className="preview-footer__menu-item-1">
                      <div className="svg-next-icon ic-plus-circle-2"
                      >
                      </div>
                    </div>
                    <div className="preview-footer__menu-item-2">
                      <div className="svg-next-icon ic-input-preview-message">
                      </div>
                    </div>
                    <div className="preview-footer__menu-item-3">
                      <div className="svg-next-icon next-icon-menu">
                      </div>
                    </div>
                  </div>
                  <div className="preview-footer__bottom-bar">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Keyword;